var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormHelperText from '@mui/material/FormHelperText';
import SelectMui from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import { Controller } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
export function Select(_a) {
    var ariaLabelledby = _a.ariaLabelledby, name = _a.name, label = _a.label, options = _a.options, defaultValue = _a.defaultValue, props = __rest(_a, ["ariaLabelledby", "name", "label", "options", "defaultValue"]);
    return (_jsx(Controller, { defaultValue: defaultValue, name: name, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return (_jsxs(FormControl, { error: Boolean(fieldState.error), fullWidth: true, children: [label ? _jsx(InputLabel, { id: "".concat(name, "-label"), children: label }) : null, _jsx(SelectMui, __assign({}, field, { "aria-labelledby": ariaLabelledby || name, error: Boolean(fieldState.error), labelId: "".concat(name, "-label"), label: label }, props, { children: options.map(function (elem) { return (_jsx(MenuItem, { value: elem.value, children: elem.name }, elem.id)); }) })), _jsx(FormHelperText, { children: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })] }));
        } }));
}
